<template>
  <div id="v2-course-list">
    <BottomBar />
    <Top :is-show-area-button="false" :welcome="false" @user="isShowUser = true" />
    <keep-alive>
      <Tab
        v-if="courseTypes[0]"
        class="tab"
        :course-types="courseTypes"
        :default-type="selectedCourseType"
        @selected="selectedCourseType = $event"
      />
    </keep-alive>
    <div v-if="!courses.length" class="empty">
      <InlineLoading />
    </div>
    <div v-else>
      <Shortcuts location="courses" />
      <!-- <Promo v-if="$store.state.isPrePromo || $store.state.isPromo" /> -->
      <div class="items">
        <Item
          v-for="course in courses.reduce((arr, i) => (arr = arr.concat(i.course)), [])"
          v-show="selectedCourseType.id === 0 || course.type_id === selectedCourseType.id"
          :key="course.id"
          :data="course"
        />
      </div>
    </div>
    <User v-if="isShowUser" @close="isShowUser = false" />
  </div>
</template>
<script>
import Top from "@/components/public/top"
import User from "@/components/my/User"
import Tab from "./Tab"
// // import Promo from "./Promo"
import Item from "./Item"
import BottomBar from "@/components/public/footer"
import Shortcuts from "@/components/home/Shortcuts"
export default {
  name: "V2CourseList",
  components: {
    Top,
    User,
    // Promo,
    Tab,
    Item,
    BottomBar,
    Shortcuts,
  },
  data() {
    return {
      isShowUser: false,
      courseTypes: [],
      courses: [],
      selectedCourseType: "",
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.getData()
  },
  activated() {
    this.isShowUser = false
  },
  methods: {
    wechatInit() {
      //微信分享配置

      wx.ready(() => {
        bus.wxShareConfig({
          type: "all",
          url: `/#${this.$route.path}`,
          name: `${window.document.title}`,
          desc: "看看 AnyTeach 最新的直播课、趣蒙课，享受限时优惠。",
        })
      })
    },
    getData() {
      this.$axios(v2Url + "/course/specialCourseList").then(({ data }) => {
        const obj = data
        if (obj.code === "1000") {
          obj.msg.sort((a, b) => b.type.sort - a.type.sort)
          obj.msg.forEach(i => {
            i.course.forEach(course => {
              course.events.forEach(event => {
                event.price = parseFloat(event.price)
              })
            })
          })
          this.courses = obj.msg
          const courseTypes = this.courses.map(item => item.type).sort((a, b) => b.sort - a.sort)
          this.courseTypes = [{ name: "全部", id: 0 }, ...courseTypes]
          if (this.$route.query.type) {
            this.selectedCourseType =
              this.courseTypes.find(item => item.id === parseInt(this.$route.query.type)) || ""
          }
          return
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
#v2-course-list {
  padding-top: $top-bar + 50px;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  margin-bottom: 20px;
  .tab {
    top: $top-bar;
  }
  .empty {
    height: 30vh;
  }
}
</style>
